import { render, staticRenderFns } from "./LeadLoginBox.vue?vue&type=template&id=81763c2a&scoped=true"
import script from "./LeadLoginBox.vue?vue&type=script&lang=js"
export * from "./LeadLoginBox.vue?vue&type=script&lang=js"
import style0 from "./LeadLoginBox.vue?vue&type=style&index=0&id=81763c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81763c2a",
  null
  
)

export default component.exports